<template>
  <b-modal
    id="confirm-fleet-modal"
    ref="confirm-fleet-modal"
    size="md"
    centered
    hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    :title="$t('global.confirmation.title')"
  >
    <div class="card-body p-2">
      <McAlert withIcon class="w-100 mb-3" variant="warning">
        <template #label>
          <p class="m-0" v-html="$t('fleetTaskInstant.text.vehicleAlreadyAssigned', { licensePlate: vehicle.licensePlate, foNumber: vehicle.fleetTask.number })" />
        </template>
      </McAlert>
      <div>
        {{ $t('fleetTaskInstant.text.confirmationVehicleAssigned') }}
      </div>
      <div class="mt-3">
        <b-form-checkbox v-model="isSkipFleetConfirmation" class="mb-1 mt-1" plain>
          {{ $t('fleetTaskInstant.action.doNotShowAgain') }}
        </b-form-checkbox>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="handleCancel(cancel)"
        />
        <McButton variant="primary" :text="$t('fleetTaskInstant.action.assignVehicle')" @click="handleConfirm" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McAlert from '@/components/McAlert'
import McButton from '@/components/McButton'

export default {
  components: {
    McAlert,
    McButton,
  },
  props: {
    vehicle: {
      type: Object,
      default: null,
    },
  },
  emits: ['create-quick-assignment', 'cancel'],
  data() {
    return {
      isSkipFleetConfirmation: false,
    }
  },
  methods: {
    handleCancel(cancel) {
      this.isSkipFleetConfirmation = false
      cancel()
      this.$emit('cancel')
    },

    handleConfirm() {
      if (this.skipFleetConfirmation) {
        localStorage.setItem('isSkipFleetConfirmation', 'true')
      }

      this.$bvModal.hide('confirm-fleet-modal')
      this.$emit('create-quick-assignment', this.vehicle)
    },
  },
}
</script>
